export default {
    system_alert_logs_tab_id: "Id",
    system_alert_logs_tab_created_on: "Created On",
    system_alert_logs_tab_unit_time: "Unit Time",
    system_alert_logs_tab_type: "Type",
    system_alert_logs_tab_name: "Name",
    system_alert_logs_tab_severity: "Severity",
    system_alert_logs_tab_unit_label: "Label",
    system_alert_logs_tab_driver_name: "Driver Name",
    system_alert_logs_tab_latitude: "Latitude",
    system_alert_logs_tab_longitude: "Longitude",
    system_alert_logs_tab_address: "Address",
    system_alert_logs_tab_landmark_name: "Landmark Name",
    system_alert_logs_tab_device_reading_id: "Device Reading Id",
    system_alert_logs_tab_linked_unit_label: "Linked Unit Label",
    system_alert_logs_tab_title: "System Alert Logs",
    system_alert_logs_tab_details: "Details",
    system_alert_logs_tab_contacts: "Contacts",
    system_alert_logs_tab_email: "Email",
    system_alert_logs_tab_show_last_reading_info: "Show Last Reading Info",
    system_alert_logs_tab_show_device_reading_info: "Show Device Reading Info",
    system_alert_logs_tab_view_details: "View Details",
    system_alert_logs_tab_status: "Status",
    system_alert_logs_tab_hdop: "HDOP",
    system_alert_logs_tab_rssi: "RSSI",
    system_alert_logs_tab_satellite_count: "Satellite Count",
    system_alert_logs_tab_hdop_ideal: "Ideal",
    system_alert_logs_tab_hdop_excellent: "Excellent",
    system_alert_logs_tab_hdop_good: "Good",
    system_alert_logs_tab_hdop_moderate: "Moderate",
    system_alert_logs_tab_hdop_fair: "Fair",
    system_alert_logs_tab_hdop_poor: "Poor",
    system_alert_logs_tab_hdop_unknown: "Unknown",
    system_alert_logs_tab_hdop_no_signal: "No Signal",

    system_alert_logs_graphic_view_button: "View Charts",

    system_alert_logs_graphic_view_title: "System Alert Graphics",
    system_alert_logs_graphic_view_total: "Total Alerts",
    system_alert_logs_graphic_view_by_severity: "Alerts By Severity",
    system_alert_logs_graphic_view_by_type: "Alerts By Type",
    system_alert_logs_tab_name: "Name",
    system_alert_logs_tab_type: "Type",
    system_alert_logs_tab_severity: "Severity",

    system_alert_severity_high: "High",
    system_alert_severity_medium: "Medium",
    system_alert_severity_low: "Low",

}